import { EquipmentBrowserViewMeta } from '@repo/sdk/models/components';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { omitUndefined } from '@/utils/omit-undefined';

export type EquipmentNavSearchInput = {
  routeId: string;
  /** Resolved view to land on: current route view, else default view. */
  viewId?: string;
  sectionId?: string;
  /** System view id for the System nav item. */
  systemViewId?: string;
  /** Device id for sequencer nav items. */
  equipmentId?: string;
};

// TODO: Use stable system view id from API once custom groups make view names editable.
export function resolveSystemViewId(
  views: EquipmentBrowserViewMeta[] | undefined
): string | undefined {
  const systemView = views?.find(
    (view) => view.name.toLowerCase() === AtlasRouteIds.System.toLowerCase()
  );
  return systemView?.id;
}

/**
 * Single source of truth for search params of nav items that target the equipment route.
 * Handles Equipment, System, CompressorSequencer, and CondenserSequencer; all other route ids return undefined.
 */
export const buildEquipmentNavSearch = (
  input: EquipmentNavSearchInput
): Record<string, string> | undefined => {
  switch (input.routeId) {
    case AtlasRouteIds.Equipment:
      // Return to the browser: keep view/section, never carry equipmentId (closes details drawer).
      return omitUndefined({ viewId: input.viewId, sectionId: input.sectionId });
    case AtlasRouteIds.System:
      return omitUndefined({ viewId: input.systemViewId ?? input.viewId });
    case AtlasRouteIds.CompressorSequencer:
    case AtlasRouteIds.CondenserSequencer:
      // Open a sequencer device while ensuring the underlying browser has a view.
      return omitUndefined({ viewId: input.viewId, equipmentId: input.equipmentId });
    default:
      return undefined;
  }
};
